'use client';

import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { detaultItemModal } from '../../setting/config';
import { ItfKspSwiperItemModal, ItfKspSwiperItemModalItem } from '../../setting/type';
import Close from './Close';
import './index.scss';
import React from 'react';

interface Props {
    theme: 'white' | 'black';
    data: ItfKspSwiperItemModal & { id: string };
    callback: () => void;
}
export default function Content({ theme = 'white', data = { ...detaultItemModal, id: '' }, callback }: Props) {
    // console.log('themem', theme);
    const { id, items = [] as ItfKspSwiperItemModalItem[], name, text } = data as ItfKspSwiperItemModal & { id: string };
    const prefixCls = 'ksp-swiper-tabs-modal';
    const [isClient, setClient] = useState(false);
    const hasItems = items?.some((item: ItfKspSwiperItemModalItem) => item?.name || item?.text || item?.pc);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setClient(true);
        }
    }, []);

    return (
        <>
            {isClient &&
                createPortal(
                    <div className={`${prefixCls} ${prefixCls}-${id} theme-${theme}`}>
                        <div className={`${prefixCls}-content`}>
                            <div className={`${prefixCls}-content-close`}>
                                <Close callback={callback} />
                            </div>
                            <div className={`${prefixCls}-content-info`}>
                                {name && (
                                    <p className={`${prefixCls}-content-info-name`} title={name}>
                                        {name}
                                    </p>
                                )}
                                {text && (
                                    <p className={`${prefixCls}-content-info-text`} title={text}>
                                        {text}
                                    </p>
                                )}
                            </div>
                            {hasItems && (
                                <ul className={`${prefixCls}-content-items`}>
                                    {items?.map((item: ItfKspSwiperItemModalItem, i: number) => (
                                        <li className={`${prefixCls}-content-items-item`} key={i}>
                                            {(item?.name || item?.text) && (
                                                <div className={`${prefixCls}-content-items-item-info`}>
                                                    {item?.name && (
                                                        <p className={`${prefixCls}-content-items-item-info-name`} title={item?.name}>
                                                            {item?.name}
                                                        </p>
                                                    )}
                                                    {item?.text && (
                                                        <p className={`${prefixCls}-content-items-item-info-text`} title={item?.text}>
                                                            {item?.text}
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                            {item?.pc && (
                                                <div className={`${prefixCls}-content-items-item-img`}>
                                                    <EcoImg pc={item?.pc} pad={item?.pc} h5={item?.h5} alt={item?.name} aria-label={item?.name} />
                                                </div>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>,
                    document.body,
                )}
        </>
    );
}
